import healthClient from './health'

function chart(data) {
    return healthClient.post('chart', data).then(response => {
        return response.data;
    }).catch(e => {
        throw e
    });
}

function storeDiary(diaryName, records) {
    return healthClient.post(`diary/${diaryName}`, records).then(response => {
        return response.data;
    }).catch(e => {
        throw e
    });
}

export default {
    chart,
    storeDiary
}
